<template lang="pug">
control
  field(:class="{ invalid: !phone.meta.valid && phone.meta.touched }")
    label(:for="phone.id")(v-html="phone.label")
    input(
      @blur="phone.blur",
      v-model="phone.model",
      v-mask="phone.mask",
      :type="phone.type",
      :name="phone.id",
      :placeholder="phone.placeholder",
      :id="phone.id"
    )

    error(v-if="!phone.meta.valid && phone.meta.touched") {{ phone.errorMessage }}
</template>

<script>
import { useStore } from "vuex";
import { reactive, computed } from "vue";
import { useField } from "vee-validate";
import * as yup from "yup";

export default {
  name: "Phone",
  props: {
    field: Object,
  },
  setup(p) {
    const store = useStore();
    const phone = reactive(initPhone());


    return { phone};

    function initPhone() {
      let labelHtml = (p.field.label) ? p.field.label : "Phone Number";
      if (p.field.required !== false) labelHtml = `<b>${labelHtml}</b>`;

      const id = `${p.field.id}`;
      const label = `${labelHtml} <span class="${p.field.required === false ? 'not-' : ''}required">*</span>`;
      const type = "tel";
      const mask = "(###) ###-####";

      const regex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
      const error = "Use the (###) ###-#### format";
      const rules =
        p.field.required === false
          ? yup
            .string()
            .matches(regex, { message: error, excludeEmptyString: true })
          : yup.string().required().matches(regex, { message: error });

      const { value, errorMessage, meta, handleBlur, validate } = useField(
        id,
        rules,
        {
          validateOnInput: true,
          initialValue: store.getters.model[id],
        }
      );

      const model = computed({
        get: () => store.getters.model[id],
        set: (v) => {
          value.value = v;
          store.commit("updateModel", { id, value: v });
        },
      });

      const blur = async () => {
        store.commit("pushLastFieldToDataLayer", id);
        await validate();
        handleBlur();
      };

      const placeholder = p.field.required === false
        ? ""
        : "(Required)";

      return { id, label, type, mask, model, meta, blur, errorMessage, placeholder };
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
